import { Card, Skeleton } from '@oresundsbron/bridge-ui';
import { FC } from 'react';

const SkeletonArticle: FC = () => (
  <Card.Root className="group relative flex flex-col-reverse">
    <Card.Header className="flex h-32 flex-col justify-between bg-neutral-200">
      <Skeleton.Root className="flex h-full flex-col justify-between">
        <Skeleton.Item intent="text" width="md" size="sm" className="mt-0" />
        <Skeleton.Item intent="text" size="xl" width="full" />
      </Skeleton.Root>
    </Card.Header>
    <Card.Content className="relative h-64 overflow-hidden">
      <Skeleton.Root className="absolute inset-0">
        <Skeleton.Item width="full" size="full" className="mt-0" />
      </Skeleton.Root>
    </Card.Content>
  </Card.Root>
);

export default SkeletonArticle;
